import { render, staticRenderFns } from "./MemberInviteModal.vue?vue&type=template&id=1cfb3c80&scoped=true"
import script from "./MemberInviteModal.vue?vue&type=script&lang=ts"
export * from "./MemberInviteModal.vue?vue&type=script&lang=ts"
import style0 from "./MemberInviteModal.vue?vue&type=style&index=0&id=1cfb3c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb3c80",
  null
  
)

export default component.exports